<template>
    <div class="table"
        element-loading-background = "rgba(255, 255,255,0.7)"
        :element-loading-text = "loadingText"
        v-loading="loading" 
        > 

        <div v-for="(indexItem, indexN) in indexData" :key="indexN">
            <div>
                <span v-html="indexItem.indexName"></span>
                <span v-if="indexItem.indexType == 'select'">
                    <el-select v-model="form.indexName['indexName'+indexN]"  clearable style="width:60%;"
                        collapse-tags placeholder="请选择">
                        <el-option
                            v-for="item in indexItem.indexSourceData"
                            :key="item.index1"
                            :label="item.index1"
                            :value="item.index1">
                        </el-option>
                    </el-select>
                </span>
            </div>

            <div v-if="indexItem.indexType == 'select'">
                <span   v-for="(indexSourceData, i) in indexItem.indexSourceData" :key="i">
                    <span v-if="form.indexName['indexName'+indexN] == indexSourceData.index1" v-html="indexSourceData.index2"></span>
                </span>
            </div>

            <el-input style="margin-top:5px;"
                type="textarea"
                placeholder="自我评述"
                v-model="form.selfComment['selfComment'+indexN]"
                maxlength="300"
                rows="3"
                show-word-limit>
            </el-input>

            <div>
                <div class="add-file-right" style="height:25px;">
                    <span class="add-file-right-img" >上传文件：</span>
                    <input type="file" ref="clearFile" @change="getFile($event,indexN)" class="add-file-right-input" accept="*">
                </div>
                <div class="add-file-list">
                    <ul>
                        <li v-for="(item, index) in form.selfCommentFile['selfCommentFile'+indexN]" :key="index" style="list-style-type: none;">
                            <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button><el-button type="text" @click="deleteFile(item.filePath)" style="margin-left:10px;cursor:pointer;color:red;">删除</el-button> 
                        </li>
                    </ul>
                </div>
            </div>

            <div  v-if="indexItem.indexScoreType == 1 ">
                <el-select  style="margin-top:5px;"
                    v-model="form.selfScoreLabel['selfScoreLabel'+indexN]" clearable placeholder="请选择自评得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>

            <div  v-if="indexItem.indexScoreType == 2 ">
                <el-select  style="margin-top:5px;"
                    v-model="form.selfScoreLabel['selfScoreLabel'+indexN]" clearable placeholder="请选择自评得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
                <el-input v-model="form.selfScore['selfScore'+indexN]" placeholder="请输入自评得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,1)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 3 ">
                <el-input v-model="form.selfScore['selfScore'+indexN]" placeholder="请输入自评得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,1)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 4 ">
                <div v-if="indexItem.indexType == 'student'">
                    <div v-for="(s, n) in form.selfDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,1)"
                                :options="levelData" filterable
                                v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择级别"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称" maxlength="10" style="width:150px;"></el-input>
                        <el-cascader  style="width:200px;"
                                :options="students" filterable
                                v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                :props="props"
                                placeholder="请选择学生"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,1)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">自评得分：{{form.selfScore['selfScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,1)">新增</el-button></div>
                </div>

                <div v-else-if="indexItem.indexType == 'self'">
                    <div v-for="(s, n) in form.selfDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,1)"
                                :options="citeData" filterable
                                v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择表彰"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.selfDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目" maxlength="10" style="width:150px;"></el-input>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,1)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">自评得分：{{form.selfScore['selfScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,1)">新增</el-button></div>
                </div>

            </div>

            <el-input style="margin-top:5px;"
                type="textarea"
                placeholder="学校批注"
                v-model="form.schoolComments['schoolComments'+indexN]"
                maxlength="300"
                rows="3"
                show-word-limit>
            </el-input>

            <div  v-if="indexItem.indexScoreType == 1 ">
                <el-select  style="margin-top:5px;"
                    v-model="form.schoolScoreLabel['schoolScoreLabel'+indexN]"  clearable placeholder="请选择学校得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>

            <div  v-if="indexItem.indexScoreType == 2 ">
                <el-select  style="margin-top:5px;"
                    v-model="form.schoolScoreLabel['schoolScoreLabel'+indexN]"  clearable placeholder="请选择学校得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
                <el-input v-model="form.schoolScore['schoolScore'+indexN]" placeholder="请输入学校得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,2)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 3 ">
                <el-input v-model="form.schoolScore['schoolScore'+indexN]" placeholder="请输入学校得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,3)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 4 ">
                <div v-if="indexItem.indexType == 'student'">
                    <div v-for="(s, n) in form.schoolDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,2)"
                                :options="levelData" filterable
                                v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择级别"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称" maxlength="10" style="width:150px;"></el-input>
                        <el-cascader  style="width:200px;"
                                :options="students" filterable
                                v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                :props="props"
                                placeholder="请选择学生"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,2)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">学校得分：{{form.schoolScore['schoolScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,2)">新增</el-button></div>
                </div>

                <div v-else-if="indexItem.indexType == 'self'" style="margin-top:5px;">
                    
                    <div v-for="(s, n) in form.schoolDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,2)"
                                :options="citeData" filterable
                                v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择表彰"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.schoolDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目" maxlength="10" style="width:150px;"></el-input>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,2)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">学校得分：{{form.schoolScore['schoolScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,2)">新增</el-button></div>
                </div>

            </div>

            <el-input style="margin-top:5px;"
                type="textarea"
                placeholder="学区批注"
                v-model="form.areaComments['areaComments'+indexN]"
                maxlength="300"
                rows="3"
                show-word-limit>
            </el-input>

            <div  v-if="indexItem.indexScoreType == 1 ">
                <el-select style="margin-top:5px;"
                    v-model="form.areaScoreLabel['areaScoreLabel'+indexN]" clearable placeholder="请选择学区得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
            </div>

            <div  v-if="indexItem.indexScoreType == 2 ">
                <el-select style="margin-top:5px;"
                    v-model="form.areaScoreLabel['areaScoreLabel'+indexN]" clearable placeholder="请选择学区得分">
                    <el-option
                        v-for="item in scoreTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                </el-select>
                <el-input v-model="form.areaScore['areaScore'+indexN]" placeholder="请输入学区得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,3)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 3 ">
                <el-input v-model="form.areaScore['areaScore'+indexN]" placeholder="请输入学区得分" maxlength="5" @keyup.native="keyupEvent($event,indexN,indexItem.indexScore,3)" style="width:150px;margin-top:5px;"></el-input>
            </div>

            <div  v-if="indexItem.indexScoreType == 4 ">
                <div v-if="indexItem.indexType == 'student'">
                    <div v-for="(s, n) in form.areaDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,3)"
                                :options="levelData" filterable
                                v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择级别"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入项目名称" maxlength="10" style="width:150px;"></el-input>
                        <el-cascader  style="width:200px;"
                                :options="students" filterable
                                v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['indexStudent']"
                                :props="props"
                                placeholder="请选择学生"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,3)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">学区得分：{{form.areaScore['areaScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,3)">新增</el-button></div>
                </div>

                <div v-else-if="indexItem.indexType == 'self'" style="margin-top:5px;">
                     
                     <div v-for="(s, n) in form.areaDefineScore[indexItem.id+'define'+indexN]" :key="n" style="margin-top:5px;">
                        <el-cascader  style="width:200px;" @change="selecAutoScore(indexItem,indexN,3)"
                                :options="citeData" filterable
                                v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['id']"
                                :props="{ expandTrigger: 'hover' }"
                                placeholder="请选择表彰"
                                collapse-tags
                                clearable>
                        </el-cascader>
                        <el-input v-model="form.areaDefineScore[indexItem.id+'define'+indexN][n]['item']" placeholder="请输入表彰项目" maxlength="10" style="width:150px;"></el-input>
                        <el-button type="text" style="margin-left:10px;cursor:pointer;" @click="delScore(indexItem,indexN,n,3)">删除</el-button>
                    </div>
                    <div style="font-size:15px;font-weight:bold;">学区得分：{{form.areaScore['areaScore'+indexN]}}分<el-button type="success" style="margin-left:10px;cursor:pointer;" @click="addScore(indexItem,indexN,3)">新增</el-button></div>
                
                </div>

            </div>
            
            <el-divider></el-divider>
        </div>

        <!-- <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save()">确 定</el-button>
        </span> -->
    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                indexData:[
                ],
                deptId:"",
                tabTitle:"",
                teacherTemplateManageId:"",
                props: { multiple: true},
                form:{
                    indexId:[],
                    indexName:{},
                    selfCommentFile:{},
                    selfComment:{},
                    selfDefineScore:{},
                    selfScore:{},
                    selfScoreLabel:{},
                    schoolComments:{},
                    schoolDefineScore:{},
                    schoolScore:{},
                    schoolScoreLabel:{},
                    areaComments:{},
                    areaDefineScore:{},
                    areaScore:{},
                    areaScoreLabel:{},
                },
                scoreTypes:[],
                students:[],
                levelData:[], // 级别
                citeData:[], // 表彰
                uploadUrl:"",
                loading:false,
                loadingText:"",
            }
        },
        components: {
        },
        created:function () {
            // 获取学校ID
            let deptId=sessionStorage.getItem("selectDeptId");
            this.deptId=deptId;

            // 获取选中的tab
            let tabTitle=sessionStorage.getItem("selectTabTitle");
            this.tabTitle=tabTitle;

            // 获取模板ID
            let teacherTemplateManageId=sessionStorage.getItem("selectId");
            this.teacherTemplateManageId=teacherTemplateManageId;

            this.uploadUrl=this.uploadIndexFileUrl;
            // 初始ID存储
            for(let i=0;i<this.indexData.length;i++){
                this.form.indexId.push(this.indexData[i].id);
            }
            // 指标初始
            this.initData();
        },
        methods:{
            // 初始数据
            initData(){
                // 指标渲染
                let url  = this.teacherTemplateAssessIndexListUrl;
                let data = {
                    deptId:this.deptId,
                    tabTitle:this.tabTitle,
                    teacherTemplateManageId:this.teacherTemplateManageId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       // 初始化数据，将数据对象转成json
                       let tempData=[];
                       for(let i=0;i<res.data.length;i++){
                           let obj=res.data[i];
                           if(obj.indexType == 'select'){ // 下拉选择
                               obj.indexSourceData=JSON.parse(obj.indexSourceData);
                           }else if(obj.indexType == 'student'){ // 学生
                                let objTemp1={};objTemp1.id=[];objTemp1.item="";objTemp1.indexStudent=[];
                                let objTemp2={};objTemp2.id=[];objTemp2.item="";objTemp2.indexStudent=[];
                                let objTemp3={};objTemp3.id=[];objTemp3.item="";objTemp3.indexStudent=[];
                                let data1=[];data1.push(objTemp1);
                                let data2=[];data2.push(objTemp2);
                                let data3=[];data3.push(objTemp3);

                                this.form.selfScore['selfScore'+i]=0;
                                this.$set(this.form.selfDefineScore, obj.id+'define'+i,data1);

                                this.form.schoolScore['schoolScore'+i]=0;
                                this.$set(this.form.schoolDefineScore, obj.id+'define'+i,data2);
                                
                                this.form.areaScore['areaScore'+i]=0;
                                this.$set(this.form.areaDefineScore, obj.id+'define'+i,data3);
                           }else if(obj.indexType == 'self'){ // 教职
                                let objTemp1={};objTemp1.id=[];
                                let objTemp2={};objTemp2.id=[];
                                let objTemp3={};objTemp3.id=[];

                                let data1=[];data1.push(objTemp1);
                                let data2=[];data2.push(objTemp2);
                                let data3=[];data3.push(objTemp3);

                                this.form.selfScore['selfScore'+i]=0;
                                this.$set(this.form.selfDefineScore, obj.id+'define'+i,data1);
                                
                                this.form.schoolScore['schoolScore'+i]=0;
                                this.$set(this.form.schoolDefineScore, obj.id+'define'+i,data2);

                                this.form.areaScore['areaScore'+i]=0;
                                this.$set(this.form.areaDefineScore, obj.id+'define'+i,data3);
                           }
                           tempData.push(obj);
                       }
                       this.indexData=tempData;
                        // console.log("列表:"+JSON.stringify(this.indexData))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }

                    // 评分等级初始设置
                    this.getScoreTypes();
                    
                    // 初始学生数据
                    this.getStudents();

                    // 初始级别或者表彰
                    this.getBaseTypeCascader(2);
                    this.getBaseTypeCascader(3);

                },(err)=>{
                    console.log(err);
                });
            },
            // 获取得分类型
            getScoreTypes(){
                let url  = this.teacherAssessBaseTypeListUrl;
                let data = {
                    deptId:this.deptId,
                    type:1 // 类型（1-得分类型，2-项目，3-级别）
                };
                this.apiPost(url,data).then((res) => {
                    // console.log("列表:"+JSON.stringify(res.data))
                    if(res.status==200){
                      this.scoreTypes = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            //获取学生
            getStudents(){
                let url  = this.listCascaderUser;
                let data = {
                    deptId:this.deptId,
                    personType: 1//人员类型（1-学生，2-教职）
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.students = res.data;
                    //   console.log("学生数据:"+JSON.stringify(this.students))
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取级别/表彰
            getBaseTypeCascader(type){
                let url  = this.teacherAssessBaseTypeCascaderListUrl;
                let data = {
                    deptId:this.deptId,
                    type: type // 类型（1-得分类别，2-级别，3-表彰）
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.selects));
                    if(res.status == 200){
                        // 类型（1-得分类别，2-级别，3-表彰） 
                        if(type == 2){
                            this.levelData = res.data.selects;
                        }else if(type == 3){
                            this.citeData = res.data.selects;
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getFile(event,index){
                // console.log('上传文件下标：'+index);
                let file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    // 上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        
                        this.loading=true;
                        this.loadingText="上传中...";
                        this.uploadForm=new FormData(); 
                        // 上传文件
                        this.uploadForm.append('file', file[i]);
                        this.$axios.post(this.uploadUrl, this.uploadForm).then((res) => {
                            if(res.data.status == 200){
                                let f=res.data.data;
                                let selfCommentFile=this.form.selfCommentFile['selfCommentFile'+index];
                                if(selfCommentFile == undefined || selfCommentFile == null){
                                    this.form.selfCommentFile['selfCommentFile'+index]=[];
                                }
                                this.form.selfCommentFile['selfCommentFile'+index].push(f);
                                this.$forceUpdate(); //强制更新
                                this.loading=false;
                            }else{
                                this.$commonFn.showTip(res.data.message, 3);
                                this.loading=false;
                            }
                        }, (err) => {
                            this.loading=false;
                            console.log(err)
                            this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                        });
                    }else{
                        this.$commonFn.showTip('无法识别到该文件类型，请添加上扩展名',3);
                    }
                }
            },
            // 删除文件
            deleteFile(filePath){
                // 删除文件，根据文件路径删除
                for(let i=0;i<this.indexData.length;i++){
                    let selfCommentFile=this.form.selfCommentFile['selfCommentFile'+i];
                    if(selfCommentFile == undefined || selfCommentFile == null){
                        this.form.selfCommentFile['selfCommentFile'+i]=[];
                    }
                    
                    // 找出删除的文件，将文件删除，然后退出
                    let isPass=false;
                    for(let j=0;j<this.form.selfCommentFile['selfCommentFile'+i].length;j++){
                        let f=this.form.selfCommentFile['selfCommentFile'+i][j];
                        if(filePath == f.filePath){
                            this.form.selfCommentFile['selfCommentFile'+i].splice(j,1);
                            this.$forceUpdate(); //强制更新
                            isPass=true;
                            break;
                        }
                    }
                    
                    if(isPass){
                        break;
                    }
                }
            },
            lookFile(url){
                window.open(url);
            },
            keyupEvent(e,index,indexScore,type){ // 自我得分自动切换分数
                // let v=e.target.value.replace(/^[0-9]+(\.[0-9]{2})?$/g,'');
                // 获取选中分数
                let v="";
                if(type == 1){
                    v=this.form.selfScore['selfScore'+index];
                }else if(type == 2){
                    v=this.form.schoolScore['schoolScore'+index];
                }else if(type == 3){
                    v=this.form.areaScore['areaScore'+index];
                }
                if(v == undefined){
                    return;
                }
                // 验证分数是否合法
                let r = /^([1-9]\d*|0)(\.\d{1,2})?$/;
                let b = r.test(v);
                if(!b){
                    let count=v.split(".").length;
                    let lastVal=v.charAt(v.length-1);
                    // 输入多余的点,去除
                    if(count>2){
                        v = v.substr(0, v.length - 1);
                    }else if(lastVal !='.'){
                        v = v.substr(0, v.length - 1);
                    }
                }
                console.log(v);
                if(type == 1){ // 自评
                    if(parseInt(v)>indexScore){
                        this.form.selfScore['selfScore'+index]=indexScore;
                    }else{
                        this.form.selfScore['selfScore'+index]=v;
                    }
                }else if(type == 2){ // 学校
                    if(parseInt(v)>indexScore){
                        this.form.schoolScore['schoolScore'+index]=indexScore;
                    }else{
                        this.form.schoolScore['schoolScore'+index]=v;
                    }
                }else if(type == 3){ // 学区
                    if(parseInt(v)>indexScore){
                        this.form.areaScore['areaScore'+index]=indexScore;
                    }else{
                        this.form.areaScore['areaScore'+index]=v;
                    }
                }
            },
            addScore(data,index,type){ //自动得分新增
                if(data.indexType == 'student'){ // 学生
                    let obj={};obj.id=[];obj.item="";obj.indexStudent=[];
                    if(type == 1){ // 自评得分
                        let v=this.form.selfDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 2){ // 学校得分
                        let v=this.form.schoolDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 3){ // 学区得分
                        let v=this.form.areaDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }
                }else if(data.indexType == 'self'){ // 老师
                    let obj={};obj.id=[];;
                    if(type == 1){ // 自评得分
                        let v=this.form.selfDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 2){ // 学校得分
                        let v=this.form.schoolDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }else if(type == 3){ // 学区得分
                        let v=this.form.areaDefineScore[data.id+'define'+index];
                        v.push(obj);
                    }
                }
                this.$forceUpdate(); //强制更新
            },
            delScore(data,index,n,type){ //自动得分删除
                // console.log('自评得分：'+JSON.stringify(this.form.selfDefineScore[data.id+'students'+index]));
                if(data.indexType == 'student'){ // 学生
                    if(type == 1){ // 自评得分
                        this.form.selfDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 2){ // 学校得分
                        this.form.schoolDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 3){ // 学区得分
                        this.form.areaDefineScore[data.id+'define'+index].splice(n,1);
                    }
                    this.selecAutoScore(data,index,type);
                }else if(data.indexType == 'self'){ // 老师
                    if(type == 1){ // 自评得分
                        this.form.selfDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 2){ // 学校得分
                        this.form.schoolDefineScore[data.id+'define'+index].splice(n,1);
                    }else if(type == 3){ // 学区得分
                        this.form.areaDefineScore[data.id+'define'+index].splice(n,1);
                    }
                    this.selecAutoScore(data,index,type);
                }
                this.$forceUpdate(); //强制更新
            },
            selecAutoScore(indexData,index,type){ // 算自动选中的分数
                let url  = this.teacherAssessBaseTypeGetAutoScoreUrl;
                let selects="";
                if(type == 1){ // 自评得分
                   selects=JSON.stringify(this.form.selfDefineScore[indexData.id+'define'+index]);
                }else if(type == 2){ // 学校得分
                    selects=JSON.stringify(this.form.schoolDefineScore[indexData.id+'define'+index]);
                }else if(type == 3){ // 学区得分
                    selects=JSON.stringify(this.form.areaDefineScore[indexData.id+'define'+index]);
                }
                let data = {
                    selectScore:selects
                };
                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        let total=res.data;
                        // console.log('后台获取分数：'+total);
                        if(total>indexData.indexScore){
                            total=indexData.indexScore;
                        }
                        // console.log('赋值的分数：'+total);
                        if(indexData.indexType == 'student'){ // 学生
                            if(type == 1){ // 自评得分
                                this.form.selfScore['selfScore'+index]=total;
                            }else if(type == 2){ // 学校得分
                                this.form.schoolScore['schoolScore'+index]=total;
                            }else if(type == 3){ // 学区得分
                                this.form.areaScore['areaScore'+index]=total;
                            }
                        }else if(indexData.indexType == 'self'){ // 老师
                            if(type == 1){ // 自评得分
                                this.form.selfScore['selfScore'+index]=total;
                            }else if(type == 2){ // 学校得分
                                this.form.schoolScore['schoolScore'+index]=total;
                            }else if(type == 3){ // 学区得分
                                this.form.areaScore['areaScore'+index]=total;
                            }
                        }
                        this.$forceUpdate(); //强制更新
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                }); 
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/gkxq/Occupation.vue